import React, { lazy, Suspense } from 'react';
import { selectShowWhiteboardLoader } from 'features/whiteboard/whiteboardSlice';
import { useAppSelector } from 'store/hooks';
import { WhiteboardLoader } from 'features/whiteboard/WhiteboardLoader';

const Whiteboard = lazy(() => import('./Whiteboard/Whiteboard'));

type WhiteboardPanelProps = {
  isPreview?: boolean;
};

export const WhiteboardPanel = ({ isPreview }: WhiteboardPanelProps = {}) => {
  const showLoader = useAppSelector(selectShowWhiteboardLoader);

  return (
    <>
      <Suspense fallback={null}>
        <Whiteboard isPreview={isPreview} />
      </Suspense>
      {showLoader ? <WhiteboardLoader /> : null}
    </>
  );
};
